import { envPublic, warnIfMissingCloudFunctionUrlInDev } from '@/libs/config';
import { getAuthToken } from '@/libs/firebase/auth';
import { applyInterceptors, createApiClient } from '../api-client';
import { createApiFactory } from '../api-factory';
import { createFirebaseCloudFunctionsAbortInterceptor } from '../firebase-cloud-functions-scope';
import {
  createAuthInterceptor,
  createCloudFunctionsBaseUrlInterceptor,
  createErrorInterceptor,
  createNetworkCheckInterceptor,
} from '../interceptors';
import type { TokenProvider } from '../types';

const firebaseTokenProvider: TokenProvider = {
  getAccessToken: async () => {
    return await getAuthToken();
  },
  getRefreshToken: async () => null,
  setTokens: async () => {},
  clearTokens: async () => {},
};

warnIfMissingCloudFunctionUrlInDev();

// `baseURL` here is just the dev default; the request interceptor below
// overrides it per-request based on the selected Firebase env.
const firebaseClient = createApiClient({
  baseURL: envPublic.firebaseCloudFunctionUrl,
});

applyInterceptors(
  firebaseClient,
  [
    createCloudFunctionsBaseUrlInterceptor(),
    createFirebaseCloudFunctionsAbortInterceptor(),
    createAuthInterceptor(firebaseTokenProvider),
    createNetworkCheckInterceptor(),
  ],
  [createErrorInterceptor()],
);

export const firebaseCloudFunctionService = createApiFactory(firebaseClient);
